import * as TK from 'components/Session/Alert/translations/locale.constants';

export const lockAlertCommonLocale = {
  [TK.SL_DELIVERY_TITLE]: 'Delivery to {{zip}} on {{date}}',
  [TK.SL_PICKUP_ZIP_TITLE]: 'Pickup from {{zip}} on {{date}}',
  [TK.SL_PICKUP_STORE_TITLE]: 'Pickup from {{store}} on {{date}}',
  [TK.SL_RESET]: 'Reset',
};
